import { PropsWithChildren, useCallback, useState } from 'react'
import {
  MainNavigateContext,
  SetMainNavigateContext
} from '../context/MainNavigateContext'
import type { MainNavigate } from '../typings/MainNavigate'

export const MainNavigateProvider = ({
  children
}: PropsWithChildren<unknown>) => {
  const [mainNavigate, setMainNavigate] = useState<MainNavigate | undefined>(
    undefined
  )

  const handleSetMainNavigate = useCallback((mainNavigate: any) => {
    setMainNavigate(() => mainNavigate)
  }, [])

  return (
    <MainNavigateContext.Provider value={mainNavigate}>
      <SetMainNavigateContext.Provider value={handleSetMainNavigate}>
        <>{children}</>
      </SetMainNavigateContext.Provider>
    </MainNavigateContext.Provider>
  )
}
